module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/root//main-bg.jpg?v=3538b38c";